export default "__VITE_ASSET__ClrFvX4F__"